import { env } from "@gsa/config/client";

export const BASE_URL = `https://${env.NEXT_PUBLIC_CDN_DOMAIN}`;

export const createCDNUrl = (src: string) => {
  const url = new URL(src?.replace("/raw", "/image"), BASE_URL);
  return url.toString();
};
